<div class="activity-layout">
  <!-- LEFT -->
  <div class="list-panel">

    <div class="search-fields">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'global.civilId' | translate }}</mat-label>
        <input matInput
               [formControl]="filterCivilId"
               (keyup.enter)="resetAndLoad()" />
        <!-- TODO: use global clear field component -->
        <mat-icon matSuffix
                  class="suffix-clickable"
                  mat-icon-button
                  (click)="clearFilters('civilId')">clear</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'global.name' | translate }}</mat-label>
        <input matInput
               [formControl]="filterName"
               (keyup.enter)="resetAndLoad()" />
        <mat-icon matSuffix
                  class="suffix-clickable"
                  mat-icon-button
                  (click)="clearFilters('name')">clear</mat-icon>
      </mat-form-field>
      <!-- <mat-form-field appearance="outline">
          <mat-label>{{ 'global.email' | translate }}</mat-label>
          <input matInput [formControl]="filterEmail" (keyup.enter)="resetAndLoad()" />
          <mat-icon matSuffix class="suffix-clickable" mat-icon-button (click)="clearFilters('email')">clear</mat-icon>
        </mat-form-field> -->
      <mat-form-field appearance="outline">
        <mat-label>{{ 'bankInfo.activity.period.label' | translate }}</mat-label>
        <mat-select [formControl]="filterPeriod"
                    (selectionChange)="resetAndLoad()">
          @for (period of periodOptions; track period) {
          <mat-option [value]="period">
            {{ 'bankInfo.activity.period.' + period | translate }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-icon-button
              color="primary"
              (click)="resetAndLoad()">
        <mat-icon>search</mat-icon>
      </button>
    </div>

    @if (listLoading && users.length === 0) {
    <div class="progress-spinner-container">
      <mat-spinner class="progress-spinner"
                   strokeWidth="10"
                   [diameter]="100"></mat-spinner>
    </div>
    } @else if (!listLoading && users.length === 0) {
    <div class="no-results">
      <mat-icon>search_off</mat-icon>
      <h4>{{ 'bankInfo.activity.noUsers' | translate }}</h4>
    </div>
    } @else {
    <div class="table-scroll-container"
         #tableScrollContainer
         (scroll)="onTableScroll($event)">
      <itfg-data-table [data]="users"
                       [columns]="columns"
                       [isSortable]="true"
                       [isClickable]="true"
                       [stickyHeader]="true"
                       (clickedRow)="onRowClick($event)"
                       (onSort)="onSortChange($event)">
        <ng-template itfgDataTableTemplate="brand"
                     let-row="row">
          <itfg-brand-logo [brand]="row.brand"
                           size="14px"></itfg-brand-logo>
        </ng-template>
        <ng-template itfgDataTableTemplate="fullName"
                     let-row="row">
          <div class="user-cell">
            <span>
              {{ row.fullName }}
              @if (+row.requestsCountForPeriod > 0 && +row.consentsCountForPeriod === 0) {
              <mat-icon class="warn-indicator"
                        matTooltip="{{ 'bankInfo.activity.noConsentsWarning' | translate }}">warning</mat-icon>
              }
            </span>
          </div>
        </ng-template>

        <ng-template itfgDataTableTemplate="civilId"
                     let-value="value">
          <span>{{ value }}</span>
        </ng-template>

        <ng-template itfgDataTableTemplate="requestsCountForPeriod"
                     let-value="value">
          <span>{{ value }}</span>
        </ng-template>

        <ng-template itfgDataTableTemplate="lastRequestAt"
                     let-value="value">
          @if (value) {
          <span [matTooltip]="value | date:'dd.MM.yyyy HH:mm'">{{ value | timeAgo }}</span>
          }
        </ng-template>

        <ng-template itfgDataTableTemplate="consentsCountForPeriod"
                     let-value="value">
          <span>{{ value }}</span>
        </ng-template>
      </itfg-data-table>

      @if (loadingMore) {
      <div class="progress-spinner-container">
        <mat-spinner class="progress-spinner"
                     strokeWidth="10"
                     [diameter]="100">
        </mat-spinner>
      </div>
      }
    </div>
    }
  </div>

  <!-- RIGHT -->
  <div class="detail-panel">
    @if (!selectedUser) {
    <div class="detail-placeholder">
      <mat-icon class="placeholder-icon">account_balance</mat-icon>
      <span>{{ 'bankInfo.activity.selectUser' | translate }}</span>
    </div>
    } @else {
    <!-- Connected Banks -->
    <div class="connected-banks-header">
      <b>
        {{ 'bankInfo.activity.connectedBanks' | translate }}
      </b>
      <button mat-icon-button
              (click)="openClientCredit()"
              matTooltip="{{ 'bankInfo.activity.openCredit' | translate }}"
              matTooltipPosition="above">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>
    <div class="connected-banks-section hide-scrollbar">
      @if (detailLoading) {
      <div class="progress-spinner-container detail-spinner">
        <mat-spinner class="progress-spinner"
                     strokeWidth="10"
                     [diameter]="100">
        </mat-spinner>
      </div>
      } @else if (userDetail?.consents?.length === 0) {
      <div class="no-consents">
        <span>{{ 'bankInfo.activity.noConsents' | translate }}</span>
      </div>
      } @else if (userDetail?.consents) {
      <div class="consents-grid">
        @for (consent of userDetail.consents; track $index) {
        <div class="consent-item">
          <div class="consent-header">
            <div class="consent-bank-row">
              <img class="bank-logo"
                   [matTooltip]="'bankIdCodes.' + (consent.bank_name | irisBankNameToBic) | translate"
                   [src]="consent.bank_name | irisBankNameToBic:'logo'"
                   [alt]="consent.bank_name"
                   (error)="$event.target.src = 'assets/images/bank-icons/generic-bank-icon.png'" />
              <div class="consent-bank-info">
                <span class="consent-status"
                      [class.is-active]="!consent.deactivated_at"
                      [class.is-inactive]="!!consent.deactivated_at">
                  {{ (consent.deactivated_at ? 'bankInfo.consent.statusInvalid' : 'bankInfo.consent.statusValid') |
                  translate }}
                </span>
                <span class="consent-iban"
                      [matTooltip]="consent.iban">
                  {{ consent.iban }}
                </span>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }
    </div>

    <!-- Activity Timeline -->
    <b>{{'bankInfo.activity.timeline.title' | translate}}</b>
    <div class="activity-timeline hide-scrollbar">
      <br><br>
      @if (detailLoading) {
      <div class="progress-spinner-container detail-spinner">
        <mat-spinner class="progress-spinner"
                     strokeWidth="10"
                     [diameter]="100"></mat-spinner>
      </div>
      } @else if (timelineSteps.length === 0) {
      <div class="no-consents">
        <mat-icon>history</mat-icon>
        <span>{{ 'bankInfo.activity.timeline.noEvents' | translate }}</span>
      </div>
      } @else {
      <itfg-timeline [stepConfigurations]="timelineSteps">
        <ng-template #stepContent
                     let-events="data">
          @for (event of events; track $index) {
          <div class="event-card"
               [class.expanded]="isExpanded(event)"
               [class.no-details]="!hasDetails(event)"
               (click)="hasDetails(event) && toggleEvent(event)">
            <div class="event-card-header">
              <span class="event-time">{{ event.createdAt | date:'HH:mm' }}</span>
              <img [matTooltip]="'bankIdCodes.' + (event.bankName | irisBankNameToBic) | translate"
                   class="bank-logo-small"
                   [src]="event.bankName | irisBankNameToBic:'logo'"
                   (error)="$event.target.src = 'assets/images/bank-icons/generic-bank-icon.png'" />
              <b class="event-type"
                 [attr.data-type]="event.type">
                {{ 'bankInfo.activity.timeline.' + event.type | translate }}
              </b>
              @if (event.errorMessage) {
              <span class="event-error-indicator">
                <mat-icon matTooltip="{{ 'global.error' | translate }}" fontSet="material-symbols-outlined">error</mat-icon>
              </span>
              }
            </div>

            @if (isExpanded(event)) {
            @if (event.iban || event.product || event.ownerName) {
            <div class="event-card-details">
              @if (event.ownerName) {
              <div class="event-owner">{{ event.ownerName }}</div>
              }
              @if (event.iban) {
              <span class="event-iban">{{ event.iban }}</span>
              }
              @if (event.product) {
              <span>{{ 'global.product' | translate }}: {{ event.product }}</span>
              }
            </div>
            }

            @if (event.type === TimelineEventType.CONSENT_DEACTIVATED) {
            <div class="event-card-note">
              @if (event.deactivationReason) {
              {{ 'bankInfo.activity.deactivation.' + event.deactivationReason | translate }}
              } @else {
              {{ 'bankInfo.activity.deactivation.unknown' | translate }}
              }
              @if (event.deactivatedBy && event.deactivationReason === DeactivationReason.OPERATOR) {
              ({{ 'bankInfo.activity.timeline.by' | translate }} {{ getDeactivatedByDisplay(event.deactivatedBy) }})
              }
            </div>
            }

            @if (event.errorMessage) {
            <div class="event-card-note event-card-error">
              <mat-icon color="warn" >
                warning
              </mat-icon>
              {{ event.errorMessage }}
            </div>
            }
            }
          </div>
          }
        </ng-template>
      </itfg-timeline>
      }
    </div>
    }
  </div>
</div>
